module.exports = __webpack_public_path__ + "img/logo.25af1a86.png";